import { useQuery } from 'react-query';
import { getChampionshipGames } from 'api/api';

export const useGetChampionshipGames = ({ leagueId, league }) =>
  useQuery({
    queryKey: ['getTeams', leagueId, league],
    queryFn: () => getChampionshipGames(leagueId, league),
    enabled: !!leagueId && !!league,
  });
